import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import React from 'react';
interface LegendItemProps {
  children: React.ReactNode;
  color: string;
  className?: string;
}
function LegendItem(t0) {
  const $ = _c(10);
  const {
    children,
    color: t1,
    className
  } = t0;
  const color = t1 === undefined ? "bg-status-success" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("text-foreground relative flex h-fit items-start pl-3 text-xs/4.5 font-bold", "xl:text-sm/5.5 xl:font-semibold", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== color) {
    t3 = cn("absolute top-1/2 left-0 h-2 w-2 -translate-y-1/2 rounded-full", color);
    $[2] = color;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div data-slot="legend-dot" className={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== t2 || $[8] !== t4) {
    t5 = <div data-slot="legend-item" className={t2}>{t4}{children}</div>;
    $[6] = children;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
export { LegendItem };